import { Injectable } from '@angular/core';
import { NbRoleProvider } from '@nebular/security';
import { of } from 'rxjs';
import { UserService } from './user/user.service';

@Injectable()
export class RoleProvider extends NbRoleProvider {
    constructor(private _userService: UserService) {
        super();
    }

    getRole() {
        return of(this._userService.role);
    }
}
